import { captureException } from "@sentry/react";
import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useAccountId } from "../../generic/hooks/use-account-id";
import type { MomentFormMoment } from "../types/moment-form-moment";

export function useUnrecoverableErrorLogger(): void {
  const account_id = useAccountId();
  const { control, getValues } = useFormContext<MomentFormMoment>();

  useWatch({ control, name: "unrecoverable_error" });
  const unrecoverableError = getValues("unrecoverable_error");

  useEffect(() => {
    if (!unrecoverableError) return;

    const values = getValues();
    const tags = {
      account_id,
      moment_id: values.id,
    };

    // capture in sentry that we have an error, and the current values
    captureException(new Error("Unrecoverable error in moment form"), {
      extra: {
        moment: { ...values, design: JSON.stringify(values.design) },
      },
      tags,
    });
  }, [unrecoverableError, getValues, account_id]);
}
